import Api from "@op/opds.api-base";
import log from "@op/opds.api-base/log";
import { v4 as uuidv4 } from "uuid";

const getBasePath = (window: Window) => window.apiBaseUrl;

const setupApi = () => {
  const api = new Api(getBasePath(window));
  // @ts-ignore missing typings
  log.config(api).install();
  return api;
};

const api = setupApi();

export const createReferenceNumbers = (
  basePart: string,
  amount: number,
  type: string,
  fiBase: boolean
): Promise<string[]> => {
  const body = { basePart, amount, type, fiBase };
  return api.post("/generate-reference-numbers", {
    body: JSON.stringify(body),
    headers: {
      "x-session-id": uuidv4(), //with spring-boot-4, session id is required, but on public op.fi liferay doesn't generate one
    },
  });
};

export const isAuthenticated: () => Promise<boolean> = () =>
  api.get("/generate-reference-numbers/userinfo", {
    headers: {
      "x-session-id": uuidv4(), //with spring-boot-4, session id is required, but on public op.fi liferay doesn't generate one
    },
  });
